<template>
  <div :class="`controls ${areControlsVisible ? 'open' : ''}`">
    <episodes v-model="areEpisodesVisible" />
    <spinner :active="isVideoLoading" class="loading" />
    <div @click="toggleControls" :class="`fade ${isVideoLoading ? 'active' : ''}`" />
    <div class="top-controls">
      <back-btn :canReturn="canReturn" :backRoute="backRoute" :shouldPop="true" />
    </div>
    <div class="options-container">
      <div @click="showControls" class="options-tray">
        <div class="vignette" />
        <timeline :isVisible="areControlsVisible" />
        <player-footer @toggleEpisodes="toggleEpisodes" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'controls',
  props: {
    canReturn: Boolean
  },
  data: () => ({
    controlsTimeout: null,
    areControlsVisible: false,
    areEpisodesVisible: false
  }),
  watch: {
    isMobile() {
      this.removeMouseListener()
      this.setupMouseListener()
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.window.isMobile,
      isVideoLoading: state => state.video.loading,
      playlistGroupId: state => state.video.playlistGroupData.id
    }),
    backRoute() {
      return {
        name: 'playlist-group-view',
        params: {
          id: this.playlistGroupId
        }
      }
    }
  },
  methods: {
    toggleControls(evt) {
      evt.stopPropagation()
      if (this.areEpisodesVisible) {
        this.areEpisodesVisible = false
        return
      }

      if (this.areControlsVisible) {
        this.hideControls()
      } else {
        this.showControls()
      }
    },
    showControls() {
      if (this.isMobile) {
        this.areEpisodesVisible = false
      }

      this.areControlsVisible = true
      clearTimeout(this.controlsTimeout)
      this.controlsTimeout = setTimeout(this.hideControls, 3000)
    },
    hideControls(evt) {
      this.areControlsVisible = false
      clearTimeout(this.controlsTimeout)
    },
    toggleEpisodes(evt) {
      if (this.isMobile) {
        evt.stopPropagation()
        this.hideControls()
      }

      this.areEpisodesVisible = !this.areEpisodesVisible
    },
    setupMouseListener() {
      if (!this.isMobile) {
        window.addEventListener('mousemove', this.showControls)
      }
    },
    removeMouseListener() {
      window.removeEventListener('mousemove', this.showControls)
    }
  },
  mounted() {
    this.setupMouseListener()
  },
  beforeDestroy() {
    this.removeMouseListener()
  }
}
</script>

<style lang="scss" scoped>
.controls {
  position: relative;
  transition: opacity 0.2s, bottom 0.2s, height 0.2s;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;

  .loading {
    position: absolute;
    top: calc(50% - 60px);
    left: calc(50% - 60px);
    width: 120px;
    height: 120px;
    pointer-events: none;
  }

  &:not(.open) > div:not(.loading) {
    cursor: none;

    .options-tray {
      opacity: 0;
    }
  }

  .fade {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.75);

    &.active {
      opacity: 1;
    }
  }

  .top-controls {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(0deg, rgba(37, 37, 37, 0) 0%, rgba(37, 37, 37, 0.6) 100%);
    transition: transform ease-out 0.2s;
    transform: translateY(-100%);
  }

  .options-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    pointer-events: none;

    .options-tray {
      position: relative;
      transition: transform ease-out 0.2s, opacity ease-out 0.2s;
      min-height: calc(10%);
      display: flex;
      flex-direction: column;
      transform: translateY(100%);
      pointer-events: all;

      .vignette {
        position: absolute;
        z-index: -1;
        top: -100px;
        width: 100%;
        height: 100px;
        background: linear-gradient(180deg, rgba(37, 37, 37, 0) 0%, rgba(37, 37, 37, 0.3) 100%);
        pointer-events: none;
      }
    }
  }

  &.open {
    .top-controls {
      transform: translateY(0);
    }

    .options-container .options-tray {
      transform: translateY(0);
    }
  }
}
</style>
